<script>
import Balloon from '@/assets/icons/hot-air-balloon.svg';
import Sun from '@/assets/icons/sun-2.svg';
import Menu from '@/assets/icons/menu2.svg';

export default {
  name: 'BottomBar',

  components: {
    Balloon,
    Sun,
    Menu,
  },

  props: {
    safeArea: {
      type: Number,
      default: 0,
    },
    routeName: {
      type: String,
      default: '',
    },
  },

  computed: {
    isExploreRoute() {
      const { routeName } = this;
      return routeName === 'Explore' || routeName === 'Category' || routeName === 'Stacks';
    },
  },
};
</script>

<template>
  <v-app-bar
    tag="nav"
    bottom
    color="white"
    :height="56 + safeArea"
    absolute
    scroll-target="#main-app-container"
    class="bottom-bar"
  >
    <div class="bar-content v-item-group">
      <v-btn
        color="white"
        exact
        exact-active-class="current"
        active-class="ACTIVE"
        class="px-8"
        :ripple="{ class: 'primary--text' }"
        to="/"
      >
        <span>Today</span>
        <Sun class="icon" />
      </v-btn>

      <v-btn
        color="white"
        exact
        exact-active-class="current"
        active-class="ACTIVE"
        class="px-8"
        :class="{ 'current ACTIVE v-btn--active': isExploreRoute }"
        :ripple="{ class: 'primary--text' }"
        to="/explore"
      >
        <span>Explore</span>
        <Balloon class="icon" />
      </v-btn>

      <v-btn
        color="white"
        exact
        exact-active-class="current"
        active-class="ACTIVE"
        class="px-8"
        :ripple="{ class: 'primary--text' }"
        to="/menu"
      >
        <span>Menu</span>
        <Menu class="icon" />
      </v-btn>
    </div>
  </v-app-bar>
</template>

<style lang="scss">
.bottom-bar.v-app-bar {
  .v-toolbar__content {
    height: 56px !important;
    padding: 0 !important;
    margin-bottom: var(--safe-area-inset-bottom);
  }

  .bar-content {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
    box-shadow: none;
  }

  .v-btn {
    font-size: 13px !important;
    border-radius: 0;
    box-shadow: none;
    flex: 0 1 auto;
    height: inherit;
    max-width: 168px;
    min-width: 80px;
    position: relative;
    text-transform: none;
  }

  .v-btn:before {
    background-color: transparent;
  }

  .v-btn__content {
    flex-direction: column-reverse;
    height: inherit;
  }

  svg {
    height: 23px;
    width: 23px;
    fill: currentColor;
    margin-top: 3px;
    margin-bottom: 5px;
  }

  .v-btn--active .v-btn__content {
    color: var(--v-secondary-base) !important;
  }
}
</style>
